import styled from "styled-components";

export const PendingApprovalStyles = styled.div`
  width: 100%;
  position: relative;
  position: relative;
  padding: 0 16px 16px;
  background: var(--white);

  @media (min-width: 1440px) {
    padding: 0 20px 20px;
  }

  .no-pending-approvals{
    height: calc(100dvh - 270px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader-wrapper{
    height: calc(100dvh - 170px);
transition: all 0.350s ease-in-out;

    .trial-banner-visible & {
      height: calc(100dvh - 210px);
      
   }
  }
`;
export const MessagePreviewerStyles = styled.form`
  border: 1px solid var(--gray-400);
  border-radius: 20px;
  margin: 0 0 20px;
  overflow: hidden;

.tt-editor{
  height: 300px;
  border: none;
  border-radius: 0;
}

.tt-content-area{
  padding: 0;
}

  .to,
  .subject,
  .body,
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 14px 18px;
    border-bottom: 1px solid var(--gray-400);

    .to-content {
      flex-grow: 1;
    }

    .to-content,
    .sending-date-wrap,
    .sending-date,
    .footer-buttons {
      display: flex;
      align-items: center;
      gap: 20px;
    }

    .sending-date-wrap {
      gap: 20px;
    }

    .sending-date {
      gap: 5px;
      color: var(--blue);
    }
  }

  .subject {
    justify-content: flex-start;
  }

  .body {
    display: block;
  }

  .footer {
    border: none;

    .footer-buttons {
      flex-grow: 1;
      justify-content: flex-end;
      .edit-button {
          color: var(--blue);
        background: #eaf3fe;
        border: none;
      }
    }
    button {
      padding: 10px;
    }
  }

  .label {
    display: block;
    color: var(--black);
    font-weight: 600;
  }

  input,
  textarea {
    padding: 0;
    border: none;
    border-radius: 0;
    height: auto;
    flex-grow: 1;
    resize: none;
  }
`;
